/**
 * @file API logout helper.
 */
import axios from 'axios';

import getConfig from './config';

/**
 * Revokes the session on the API and clears its auth and refresh cookies.
 *
 * @returns {Promise<void>}
 */
const logoutFromApi = async () => {
  const config = getConfig();

  await axios.post(
    `${config.graphql.clientBaseUrl}/auth/logout`,
    {},
    { withCredentials: true },
  );
};

export default logoutFromApi;
